import React from "react";
import { Grid, TextField } from "@mui/material";

export default function KeywordField({ value, classes, onChange }) {
  const handleChange = (e) => {
    onChange({ keyword: e.target.value });
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={2}
        sx={{
          fontWeight: "bold",
          paddingLeft: "10px",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        キーワード
      </Grid>
      <Grid
        item
        xs={8}
        sm={10}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <TextField
          className={classes?.inputArea}
          variant="standard"
          fullWidth
          name="keyword"
          id="keyword"
          value={value || ""}
          onChange={handleChange}
          InputProps={{
            style: { fontSize: 16 },
          }}
        />
      </Grid>
    </>
  );
}